import * as React from "react";
import { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { Box, Button, Collapse, colors, Divider, Grid, ListItemButton, ListItemIcon, ListSubheader } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import {
  ExpandLess,
  ExpandMore,
  LocalShippingOutlined,
  PersonOutlined,
  ShoppingBagOutlined,
  AccountCircle
} from "@mui/icons-material";
import liqueLogo from '../assets/liqueLogo.png'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import FormatPaintOutlinedIcon from '@mui/icons-material/FormatPaintOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import LiqueModal from '../customer/components/liqueModal';
import { useAuth } from "../authContext";

function Sidebar({ closeButton = null }) {
  const location = useLocation();
  const [openKaryawan, setOpenKaryawan] = useState(false);
  const [openStok, setOpenStok] = useState(false);
  const [openOrderDelivery, setopenOrderDelivery] = useState(false);
  const [openDecoration, setOpenDecoration] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const { auth, logout, isAllowed, isAllowedMultiple } = useAuth();

  const handleKaryawanClick = () => {
    setOpenKaryawan(!openKaryawan);
  };
  const handleStokClick = () => {
    setOpenStok(!openStok);
  };
  const handleOrderDeliveryClick = () => {
    setopenOrderDelivery(!openOrderDelivery);
  };
  const handleOpenDecorationClick = () => {
    setOpenDecoration(!openDecoration);
  }

  useEffect(() => {
    if (location.pathname.startsWith("/manager/karyawan")) {
      setOpenKaryawan(true);
    }
    if (location.pathname.startsWith("/manager/stok")) {
      setOpenStok(true);
    }
    if (location.pathname.startsWith("/manager/orderDelivery")) {
      setopenOrderDelivery(true);
    }
    if (location.pathname.startsWith("/manager/decoration")) {
      setOpenDecoration(true);
    }
  }, [location.pathname]);

  const handleLogout = () => {
    setOpenLogout(false);
    logout();
  };

  return (
    <div>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader
            component="div"
            id="nested-list-subheader"
            style={{ color: "white", backgroundColor: "black" }}
          >
            <Grid container marginTop={2} marginBottom={1}>
              <Grid item xs={6} display="flex" alignItems="center">
                <img src={liqueLogo} alt="lique logo" style={{ width: "100%" }}></img>
              </Grid>
              <Grid item xs={6} textAlign="end">
                {closeButton}
              </Grid>
            </Grid>
          </ListSubheader>
        }
      >
        {
          isAllowed("menuKelolaMitra") && (
            <ListItemButton component={Link} to="/manager/mitra">
              <StoreOutlinedIcon />
              &nbsp;&nbsp;&nbsp;
              <ListItemText primary="Mitra" />
            </ListItemButton>
          )
        }

        {
          isAllowedMultiple([
            'menuAbsensi', 'menuDataKaryawan', 'menuGajiKaryawan', 
            'menuPengaturanKaryawan', 'menuHakAkses'
          ]) && (
            <>
              <ListItem button onClick={handleKaryawanClick}>
                <PersonOutlined />
                &nbsp;&nbsp;&nbsp;
                <ListItemText primary="Karyawan" />
                {openKaryawan ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openKaryawan} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{ paddingLeft: 20 }}>
                  {isAllowed("menuAbsensi") && (
                    <ListItem button component={Link} to="/manager/karyawan/presensi">
                      <ListItemText primary="Absensi" />
                    </ListItem>
                  )}
                  {isAllowed("menuDataKaryawan") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/karyawan/dataKaryawan"
                    >
                      <ListItemText primary="Data Karyawan" />
                    </ListItem>
                  )}
                  {isAllowed("menuGajiKaryawan") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/karyawan/gajiKaryawan"
                    >
                      <ListItemText primary="Gaji Karyawan" />
                    </ListItem>
                  )}
                  {isAllowed("menuPengaturanKaryawan") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/karyawan/manageEmployee"
                    >
                      <ListItemText primary="Pengaturan Karyawan" />
                    </ListItem>
                  )}
                  {isAllowed("menuHakAkses") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/karyawan/hakAkses"
                    >
                      <ListItemText primary="Hak Akses" />
                    </ListItem>
                  )}
                </List>
              </Collapse>
            </>
          )
        }

        {
          isAllowedMultiple(['menuKelolaProduk', 'menuKelolaSku', 'menuKelolaDiskon']) && (
            <>
              <ListItem button onClick={handleStokClick}>
                <ShoppingBagOutlined />
                &nbsp;&nbsp;&nbsp;
                <ListItemText primary="Inventory" />
                {openStok ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openStok} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{ paddingLeft: 20 }}>
                  {isAllowed("menuKelolaProduk") && (
                    <ListItem button component={Link} to="/manager/stok/reviewStok">
                      <ListItemText primary="Kelola Produk" />
                    </ListItem>
                  )}
                  {isAllowed("menuKelolaSku") && (
                    <ListItem button component={Link} to="/manager/stok/tipeBarang">
                      <ListItemText primary="Kelola SKU" />
                    </ListItem>
                  )}
                  {isAllowed("menuKelolaDiskon") && (
                    <ListItem button component={Link} to="/manager/stok/diskon">
                      <ListItemText primary="Kelola Diskon" />
                    </ListItem>
                  )}
                </List>
              </Collapse>
            </>
          )
        }

        {
          isAllowedMultiple([
            'menuReviewPesanan', 'menuReviewRefund', 'menuReviewPesananMitra', 
            'menuReviewTransaksiMitra', 'menuPenarikanDana'
          ]) && (
            <>
              <ListItem button onClick={handleOrderDeliveryClick}>
                <LocalShippingOutlined />
                &nbsp;&nbsp;&nbsp;
                <ListItemText primary="Pesanan dan Pengiriman" />
                {openOrderDelivery ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openOrderDelivery} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{ paddingLeft: 20 }}>
                  {isAllowed("menuReviewPesanan") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/orderDelivery/pemesanan2"
                    >
                      <ListItemText primary="Review Pesanan Lique" />
                    </ListItem>
                  )}
                  
                  {isAllowed("menuReviewRefund") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/orderDelivery/refunds"
                    >
                      <ListItemText primary="Review Refund" />
                    </ListItem>
                  )}
                  {isAllowed("menuReviewPesananMitra") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/orderDelivery/pemesanan/mitra"
                    >
                      <ListItemText primary="Review Pesanan" />
                    </ListItem>
                  )}
                  {isAllowed("menuTransaksiMitra") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/orderDelivery/mitra/transaksi"
                    >
                      <ListItemText primary="Review Transaksi" />
                    </ListItem>
                  )}
                  {isAllowed("menuPenarikanDana") && (
                    <ListItem
                      button
                      component={Link}
                      to="/manager/orderDelivery/penarikanDana"
                    >
                      <ListItemText primary="Penarikan Dana" />
                    </ListItem>
                  )}
                </List>
              </Collapse>
            </>
          )
        }

        {
          isAllowedMultiple(['menuKelolaTag', 'menuKelolaBanner']) && (
            <>
              <ListItem button onClick={handleOpenDecorationClick}>
                <FormatPaintOutlinedIcon />
                &nbsp;&nbsp;&nbsp;
                <ListItemText primary="Dekorasi" />
                {openDecoration ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openDecoration} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{ paddingLeft: 20 }}>
                  {isAllowed("menuKelolaTag") && (
                    <ListItem button component={Link} to="/manager/decoration/tag">
                      <ListItemText primary="Kelola Brand" />
                    </ListItem>
                  )}
                  {isAllowed("menuKelolaBanner") && (
                    <ListItem button component={Link} to="/manager/decoration/banner">
                      <ListItemText primary="Kelola Theme" />
                    </ListItem>
                  )}
                </List>
              </Collapse>
            </>
          )
        }

        <Divider sx={{ background: "gray", width: "80%", margin: "10px auto" }} />
        
        <ListItem>
          <ListItemIcon>
            <PersonOutlinedIcon sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText>
            {auth?.user?.username}
          </ListItemText>
        </ListItem>
        <ListItemButton onClick={() => setOpenLogout(true)}>
          <ListItemIcon>
            <LogoutOutlinedIcon sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText>
            Log Out
          </ListItemText>
        </ListItemButton>
      </List>

      <LiqueModal open={openLogout} onClose={() => setOpenLogout(false)} width="500px">
        <Box textAlign="center">
          <AccountCircle style={{ fontSize: 100 }} />
          <Typography id="spring-modal-title" variant="h6" component="h2">
            Apakah anda yakin ingin keluar?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              onClick={() => setOpenLogout(false)}
              sx={{ mr: 2, backgroundColor: "#FE8A01", color: "white" }}
            >
              Tidak
            </Button>
            <Button variant="outlined" onClick={handleLogout}>
              Ya
            </Button>
          </Box>
        </Box>
      </LiqueModal>
    </div>
  );
}

export default Sidebar;
